
import { Box, Stack } from "@mui/material";
import { NeuromuscularSection } from "./components/NeuromuscularSection";
import { HistoryButtonsSection } from "./components/HistoryButtonsSection";
import PageThreeColumns from "./page_three_columns";

//YATAY;452641;18042025
function PageThree() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={4}>
        <NeuromuscularSection />
        <HistoryButtonsSection />
        <PageThreeColumns />
      </Stack>
    </Box>
  );
}

export default PageThree;
